import { Route, Routes, useLocation } from "react-router-dom"
import { Login } from "../login"
import { PatientRegister } from "../Patient/Register"
import { useCustomContext } from "../../state/CustomContext";
import { PatientView } from "../Patient/View";
import './index.scss'
import { AmbulanceTrack } from "../ambulance_track";
import { ParmedicalInfo } from "../paramedical_info";
import TenantCreate from "../master/Tenant/Create";
import TenantView from "../master/Tenant/View";
import HospitalCreate from "../master/Hospital/Create";
import HospitalView from "../master/Hospital/View";
import BranchCreate from "../master/Branch/Create";
import BranchView from "../master/Branch/View";
import AmbulanceCreate from "../master/Ambulance/Create";
export const Body = () => {
    const context = useCustomContext();
    const { state } = context;
    const location = useLocation();
    if ((state.token && state.role_id) || (['/', '/login'].includes(location.pathname))) {
        return <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/patient-register" element={<PatientRegister />} />
            <Route path='/Patient-view' element={<PatientView />} />
            <Route path='/ambulance-status-track' element={<AmbulanceTrack />} />
            <Route path='/paramedical-info' element={<ParmedicalInfo />} />

            <Route path="/tenant-create" element={<TenantCreate />} />
            <Route path='/tenant-view' element={<TenantView />} />

            <Route path="/hospital-create" element={<HospitalCreate />} />
            <Route path='/hospital-view' element={<HospitalView />} />

            <Route path="/branch-create" element={<BranchCreate />} />
            <Route path='/branch-view' element={<BranchView />} />

            <Route path="/ambulance-create" element={<AmbulanceCreate />} />
            <Route path='/ambulance-view' element={<BranchView />} />

        </Routes>
    } else {
        return <Login />
    }

}